import {
  Box, Button, Divider,
  Stack, Typography, useTheme
} from '@mui/material';

import RedotpayCard from "@/components/RedotpayCard";
import RpIcon from "@/components/RpIcon";
import RouteConstant from "@/constant/RouteConstant";
import {createSearchParams, useNavigate, useSearchParams} from "react-router-dom";
import {CARD_TYPE} from "@/constant/Constant.ts";
import {useBoolean, useRequest, useSize} from "ahooks";
import {getCardDetail} from "@/services";
import {getUrlParams} from "@/utils/utils";
import React, {useEffect, useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import classes from "./index.module.css";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
import { deleteCard,  } from "@/services";
import {cardDeletePay, cardDeletePreview} from "@/services/card";
import {LoadingButton} from "@mui/lab";
import AppModal from "@/components/AppModal.tsx";
import Security2FA from "@/pages/security/Security2FA.tsx";
import useToggle from "@/hook/useToggle";
import {getUserInfo, setTaskRuleParams} from "@/redux/slices/user";
import {VerifyAction} from "@/constant/VerifyConstant";
import {dispatch} from "@/redux/store";
import {getCardAvailable, getCardList} from "@/redux/slices/card";
import VarietySelectModal from "@/pages/components/VarietySelectModal";
const DeleteCard = () => {
  const cardId = getUrlParams("cardId");
  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme()
  const navigate = useNavigate();
  const {t} = useTranslation()
  const size = useSize(document.querySelector('body'));
  const paramCard = useMemo(() => {
    let ret: any = Object.fromEntries(searchParams)
    return ret
  }, [searchParams])
  const getCardDetailReq = useRequest(async () => {
    const res = await getCardDetail(cardId)
    return res as any
  }, { manual: true })

  const cardDetail = useMemo(() => {
    if (!getCardDetailReq?.data) {
      return paramCard
    }
    return getCardDetailReq?.data
  }, [getCardDetailReq?.data, paramCard])

  useEffect(() => {
    if (paramCard.hasOwnProperty('lossStatus') && paramCard.lossStatus != 1) {
      getCardDetailReq.runAsync()
    }
  }, [paramCard]);

  const deleteCardPreviewReq = useRequest(async () => {
    const res = await cardDeletePreview({cardId})
    return res
  }, {
    manual: false,
  })
  const deleteCardReq = useRequest(async () => {
    const res = await cardDeletePay({cardId})
    return res
  }, {
    manual: true,
  })

  const onDelete = () => {
    setTaskRuleParams({
      // action: _isPinSet() ? VerifyAction.PIN_CODE_UPDATE : VerifyAction.PIN_CODE_SET,
      action: VerifyAction.DELETE_CARD,
    });
    setToggleShow2FA(true);
    // deleteCardReq.runAsync().then(() => {
    //   navigate(`${RouteConstant.SUCCESS}?source=delete_card`)
    // })
  }

  const cardScale = useMemo(() => {
    const scale = size?.width / 375
    return scale
  }, [size])
  const styles = {
    padding: '0 16px'
  }

  const {
    toggle: show2FA,
    onToggle: onToggleShow2FA,
    setToggle: setToggleShow2FA,
  } = useToggle(false);

  const _on2FAAllPass = () => {
    onToggleShow2FA()
    deleteCardReq.runAsync().then(() => {
      dispatch(getUserInfo());
      dispatch(getCardList());
      dispatch(getCardAvailable());
      navigate(`${RouteConstant.SUCCESS}?source=delete_card`)
    }).catch(err => {
      // varietySelectModalOpenOperate.setTrue()
      deletePreviewModalOpenOperate.setTrue()
    })
  }

  // useEffect(() => {
  //   console.log('cardDeletePreviewReq?.data', deleteCardPreviewReq?.data)
  // }, [deleteCardPreviewReq?.data]);
  const doDeposit = () => {
    varietySelectModalOpenOperate.setTrue()
  }

  const onVarietySelected = (variety) => {
    setSelectedVariety(variety)
    navigate(`${RouteConstant.USER_DEPOSIT}?variety_code=${variety.varietyCode}`)
  }

  const [varietySelectModalOpen, varietySelectModalOpenOperate] = useBoolean(false);
  const [selectedVariety, setSelectedVariety] = useState(null);

  const [deletePreviewInfoModalOpen, deletePreviewModalOpenOperate] = useBoolean(false);

  return (
    <>
    <Stack
    sx={{
      width: '100%',
      height: '100%',
      position: 'relative'
    }}
    >
      <SimpleHeader title={t('delete_card')}/>
      <Box
      sx={{
        ...styles
      }}
      >
        <Typography
        sx={{
          fontWeight: 'bold',
          fontSize: '18px',
        }}
        >{t('delete_card')}</Typography>
        <Typography
          sx={{
            fontWeight: 'bold',
            fontSize: '12px',
            color: theme.palette.text.tertiary
          }}
        >{t('delete_card_desc')}</Typography>
      </Box>
      <Box direction="column" className={classes.card}>
        <Box className={classes.cardDetail}
             sx={theme => {
               return {
                 overflow: 'visible',
                 // width: theme.typography.pxToRem(343), //'343px',
                 height: 201 * cardScale + 'px', //theme.typography.pxToRem(), // '201px',
                 maxHeight: 201 * (520 / 375) + 'px'
               }
             }}
        >
          <RedotpayCard cardItem={cardDetail} isDelete={true} />
        </Box>
      </Box>
      <Box
        sx={{
          ...styles
        }}
      >
        <Stack
          sx={{
            ...styles,
            height: '64px',
            backgroundColor: theme.palette.background.card
          }}
          direction="row" justifyContent="space-between" alignItems="center">
          <Typography>{t('deleting_fee')}</Typography>
          <Typography sx={{
            color: theme.palette.brand.main
          }}>{deleteCardPreviewReq?.data?.deletionFee} {deleteCardPreviewReq?.data?.varietyCode}</Typography>
        </Stack>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          width: '100%',
          padding: '0 16px',
          bottom: '16px'
        }}
      >
        <LoadingButton
          size="large"
          variant="contained"
          fullWidth
          loading={deleteCardReq.loading}
          sx={{
            borderRadius:"24px"
          }}
          onClick={() => {
            onDelete()
          }}
        >
          {t('pay')} {deleteCardPreviewReq?.data?.deletionFee} {deleteCardPreviewReq?.data?.varietyCode}
        </LoadingButton>
      </Box>
    </Stack>
  <AppModal open={deletePreviewInfoModalOpen} onClose={deletePreviewModalOpenOperate.setFalse}>
    <Stack>
      <SimpleHeader
        backEnable
        title={t('pay')}
        closeButton={<RpIcon icon="close" size={14} clickable onClick={() => {
          deletePreviewModalOpenOperate.setFalse()
        }} />}
      />
      <Stack sx={{padding: '0 16px', paddingBottom: '16px'}}>
        <Stack
          direction="row" alignItems="center" justifyContent="center">
          <span style={{fontSize: '16px', fontWeight: 'bold'}}>$</span>
          <Typography
            sx={{
              fontWeight: 'bold',
              padding: '16px 0',
              color: theme.palette.text.primary,
              fontSize: '32px',
              textAlign: 'center'
            }}
          >{deleteCardPreviewReq?.data?.deletionFee}</Typography>
        </Stack>
        <Typography
          sx={{color: theme.palette.brand.main}}
          textAlign="center">{t('please_deposit')}</Typography>
        <LoadingButton onClick={() => {
          deletePreviewModalOpenOperate.setFalse()
          varietySelectModalOpenOperate.setTrue()
        }} sx={{marginTop: '16px',borderRadius:"20px"}} fullWidth variant="contained">
          {t('deposit')}
        </LoadingButton>
      </Stack>
    </Stack>

  </AppModal>
  <AppModal open={show2FA} onClose={onToggleShow2FA}>
    <Security2FA callback={_on2FAAllPass} onClose={onToggleShow2FA}/>
  </AppModal>
  <VarietySelectModal open={varietySelectModalOpen}
                      varietyOperate={'deposit'}
                  onClose={varietySelectModalOpenOperate.setFalse}
                  onSelected={onVarietySelected}
  />
  </>
);
}

export default DeleteCard;